import {
  useEmailReplyFormInitEditor,
  useEmailReplyFormShowConversation,
} from '../Email.hooks'
import { EmailCreationPopupContainer } from '../EmailCreationPopupContainer'
import { EmailReplyForm } from '../EmailReplyForm'

import * as styles from './EmailModalReplyForm.module.css'

function EmailModalReplyForm({
  contentComponentProps,
  formProps,
  initialValues,
  ...restProps
}) {
  const { editorRef, handleInitEditor } = useEmailReplyFormInitEditor()

  const { toggleExpandConversation } = useEmailReplyFormShowConversation({
    editorRef,
  })

  return (
    <EmailReplyForm
      {...restProps}
      FormContainer={EmailCreationPopupContainer}
      contentComponentProps={{
        ...contentComponentProps,
        className: null,
        shadow: true,
      }}
      formProps={{ ...formProps, className: styles.formBody }}
      initialValues={initialValues}
      onInitEditor={handleInitEditor}
      onToggleExpandConversation={toggleExpandConversation}
    />
  )
}

export default EmailModalReplyForm
